import { bindEvents } from '../../assets/js/helpers';


const selector = 'footer';

export default class Footer {

	constructor(section) {
		this.el = {
			section,
			neonSign: section.querySelector(`.${selector}__neon-sign`)
		};

		this.events = bindEvents(this);

		this.addEventListeners();
	}

	static get selector() {
		return selector;
	}

	_onNeonSignReveal() {
		this.el.neonSign.classList.add('is-lit');
	}

	addEventListeners() {
		this.el.neonSign.addEventListener('reveal', this.events._onNeonSignReveal);
	}

	removeEventListeners() {
		this.el.neonSign.removeEventListener('reveal', this.events._onNeonSignReveal);
	}

	destroy() {
		this.removeEventListeners();
	}

}
